import UrlBaseProvider from "./urlBaseProvider";

export default class HomeProvider extends UrlBaseProvider {
	constructor($http, storage, eventBus) {
		super("home", "/v2/", $http, storage, eventBus);
	}
}
